import classes from "./Users.module.css";
import axios from "axios";
import {path} from "../../../routes";
import {useEffect, useState} from "react";
import Kiosk_settings from "./KIOSK_set/Kiosk_settings";
import {CircularProgress} from "@mui/material";

const Users = (props) =>{
    const [device, setDevice] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchDataKiosk = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${path}/getKiosk?orgID=${props.cred.cOrganization_id}`);
            setDevice(response.data)
            console.log(response.data)
            setLoading(false);
        } catch (error) {
            console.error('Error deleting row:', error);

            setLoading(false);
        }
    }

    useEffect(()=>{
        fetchDataKiosk()
    },[])

    return <div className={classes.main}>
        {device.length > 0 && device.map(x => {
            return <Kiosk_settings data={x} key={x.id}/>
        })}
        {loading && <CircularProgress />}
    </div>
}
export default Users